import { render, staticRenderFns } from "./century-skills.vue?vue&type=template&id=82f2d0ea&"
import script from "./century-skills.ts?vue&type=script&lang=ts&"
export * from "./century-skills.ts?vue&type=script&lang=ts&"
import style0 from "./century-skills.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports